class LookupGroupController {
    constructor($window, $uibModal, $browser, UserDetailsApi, toastr, ModalService, LookupsServiceApi, $location, GenericMenuServiceApi) {
        this.nameRenderer = (lookup) => {
            let name = ['<span',
                'ng-if="!vm.state.clickableEdit">',
                lookup.data.LookupGroupName,
                '</span><a ng-href=""',
                'class="space-top pointer"',
                'ng-if="vm.state.clickableEdit"',
                'ng-click="vm.editLookupGroup(data)">',
                lookup.data.LookupGroupName,
                '</a>'
            ].join(' ');
            return name;
        };
        this.statusCellRenderer = () => {
            let isDeleted = ['<span',
                'ng-if="!data.IsDeleted">',
                'No',
                '</span>',
                '<span',
                'ng-if="data.IsDeleted">',
                'Yes',
                '</span>'
            ].join(' ');
            return isDeleted;
        };
        this.actionsCellRenderer = () => {
            let gotoLookup = ['<span',
                'class="btn btn-info btn-xs"',
                // 'ng-if="vm.userDetails.IsSupport"',
                'ng-click="vm.gotoLookup(data)"',
                'uib-popover="Goto Lookups for this Group"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="left"',
                'popover-append-to-body="true"',
                '>',
                '<i',
                'class="glyphicon glyphicon-cog">',
                '</i>',
                '</span>'
            ].join(' ');
            let edit = ['<span',
                'class="btn btn-info btn-xs"',
                'ng-click="vm.editLookupGroup(data)"',
                'uib-popover="Edit Lookup Group"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="left"',
                'popover-append-to-body="true"',
                '>',
                '<i',
                'class="glyphicon glyphicon-pencil">',
                '</i>',
                '</span>'
            ].join(' ');
            let deleteThis = ['<span',
                'class="btn btn-info btn-xs"',
                'ng-if="!data.IsDeleted"',
                'ng-click="vm.deleteLookupGroup(data)"',
                'uib-popover="Delete Lookup Group"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="left"',
                'popover-append-to-body="true"',
                '>',
                '<i',
                'class="glyphicon glyphicon-trash">',
                '</i>',
                '</span>'
            ].join(' ');
            return '<div class="ag-grid-actions-container">' + gotoLookup + edit + deleteThis + '</div>';
        };
        this.gotoLookup = (row) => {
            if (row.Id === null) {
                return;
            }
            let url = ['lookupGroup/', row.Id].join('');
            this.location.path(url);
        };
        // Add/Edit User section
        this.addLookupGroup = () => {
            // Create a default user
            let newGroup = { Id: -1, LookupGroupName: '', IsDeleted: false };
            this.editLookupGroup(newGroup);
        };
        this.editLookupGroup = (group) => {
            let lookupGroupEditModal = this.uibModal.open({
                animation: true,
                component: 'addEditLookupGroupModal',
                size: 'md',
                resolve: {
                    group: () => {
                        return group;
                    }
                }
            });
            lookupGroupEditModal.result.then(() => {
                this.getLookupGroups();
            });
        };
        this.deleteLookupGroup = (group) => {
            let modalOptions = {
                actionButtonText: 'OK',
                closeButtonText: 'Cancel',
                headerText: 'Delete Lookup Group',
                bodyText: 'Are you sure you want to delete ' + group.LookupGroupName + ' ?'
            };
            this.ModalService.showModal({}, modalOptions).then(() => {
                this.LookupGroupService.deleteLookupGroup(group.Id).then((response) => {
                    let succeeded = ((response.status === 200) && (response.data === true));
                    if (succeeded) {
                        group.IsDeleted = true;
                        this.getLookupGroups();
                        return;
                    }
                    let reason = 'Failed to delete Lookup Group';
                    this.toastr.error(reason + '.', 'User Error');
                    // console.log(reason + ' ' + group.SimName);
                });
            });
        };
        this.getLookupGroups = () => {
            this.LookupGroupService.getAllLookupGroups().then((response) => {
                this.gridOptions.api.setRowData(response.data);
                this.gridOptions.api.sizeColumnsToFit();
            });
        };
        this.viewGroup = (group) => {
            let url = [this.browser.baseHref(), 'Lookup/Index#/lookupGroup/', group.Id].join('');
            this.window.location.href = url;
        };
        this.init = () => {
            this.GenericMenuServiceApi.roleOptionAllowed('lookupGroup').then((response) => {
                // Not allowed - back to home
                if (!response.data) {
                    this.location.path('/');
                    return;
                }
                this.debug = false;
                this.passwordUser = false;
                this.UserDetails = null;
                let columns = [
                    { headerName: 'Id', field: 'Id', width: 80, minWidth: 55, maxWidth: 80, hide: false, resizable: false, sort: 'asc' },
                    { headerName: 'Name', width: 575, minWidth: 80, field: 'LookupGroupName', cellRenderer: this.nameRenderer, suppressMovable: true },
                    { headerName: 'Deleted', width: 75, minWidth: 75, maxWidth: 75, field: 'IsDeleted', cellClass: 'text-center', cellRenderer: this.statusCellRenderer, suppressMenu: true, resizable: true, suppressMovable: true },
                    { headerName: 'Actions', width: 120, minWidth: 120, maxWidth: 120, cellRenderer: this.actionsCellRenderer, sortable: true, suppressMenu: true, resizable: true, suppressMovable: true }
                ];
                this.columnDefs = columns;
                this.rowCount = 0;
                this.state = {
                    clickableEdit: true
                };
                this.gridOptions = {
                    defaultColDef: {
                        sortable: true,
                        filter: true,
                        resizable: true,
                    },
                    columnDefs: this.columnDefs,
                    angularCompileRows: true,
                    suppressMovableColumns: true // Added because of ag-grid bug see https://github.com/ceolter/ag-grid/issues/965#issuecomment-225857509
                };
                this.UserDetailsApi.get().then((data) => {
                    this.UserDetails = data;
                });
                this.getLookupGroups();
            });
        };
        this.$onInit = () => {
            this.init();
        };
        this.window = $window;
        this.uibModal = $uibModal;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.browser = $browser;
        this.LookupGroupService = LookupsServiceApi;
        this.UserDetailsApi = UserDetailsApi;
        this.location = $location;
        this.GenericMenuServiceApi = GenericMenuServiceApi;
    }
}
angular.module('app').component('lookupGroup', {
    bindings: {},
    templateUrl: 'scripts/app/partials/LookupGroup/lookup-group.tpl.html',
    controllerAs: 'vm',
    controller: LookupGroupController
});
